export const paymentSchedule = {
  date: "System.DateTime",
  decimal: "System.Decimal",
};
